import React from 'react';
import c from 'classnames';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Audio } from '../../../components';

import './style.scss';

const ParagraphAudio = ({ entity, className }) => {
  const classNames = c('Paragraph', 'ParagraphAudio', className);

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed'], '');
  const url = entity.getIn(['field_media_item', 0, 'entity', 'field_media_audio_file', 0, 'url'], '');

  return (
    <article className={classNames}>
      {title.length > 0 && (
        <div className="ParagraphAudio__title">
          <h2>{title}</h2>
        </div>
      )}

      {text.length > 0 && (
        <div className="ParagraphAudio__text">
          <WysiwygField
            property="schema:text"
            html={text}
          />
        </div>
      )}

      {url.length > 0 && (
        <Audio url={url} />
      )}
    </article>
  );
};

export default ParagraphAudio;
